export { DiscoverMWMovePage } from './DiscoverMWMovePage';
